/**
 * Asynchronously loads the component for CampusKYC
 */

import { lazyLoad } from "utils/loadable";

export const CampusKYC = lazyLoad(
  () => import("./index"),
  (module) => module.CampusKYC
);
